import { Component } from '@angular/core';
import { ResultQuoteWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/result/result-wrapper.component';

@Component({
  selector: 'app-result-standard-mobile',
  templateUrl: './result-mobile.component.html',
  styleUrls: ['./result-mobile.component.scss'],
})
export class ResultMobileComponent extends ResultQuoteWrapperComponent {

}
